import { createAction, props } from '@ngrx/store';
import { type ShopCartIconSettingsType } from '@common/types/shop-cart-icon-settings.type';

export const loadCartIcon = createAction('[Cart Icon] Load Cart Icon', props<{ siteId: string }>());

export const loadCartIconSuccess = createAction(
    '[Cart Icon] Load Cart Icon Success',
    props<{ data: ShopCartIconSettingsType; isCartEnabled: boolean }>()
);

export const loadCartIconFailure = createAction('[Cart Icon] Load Cart Icon Failure', props<{ error: any }>());

export const saveCartIcon = createAction('[Cart Icon] Save Cart Icon', props<{ data: ShopCartIconSettingsType }>());

export const saveCartIconSuccess = createAction(
    '[Cart Icon] Save Cart Icon Success',
    props<{ data: ShopCartIconSettingsType }>()
);

export const saveCartIconFailure = createAction('[Cart Icon] Save Cart Icon Failure', props<{ error: any }>());

export const setChangedState = createAction('[Cart Icon] Set Changed State', props<{ isChanged: boolean }>());
